import React, { Component } from "react";
import { Layout, Button, Col, Row, Collapse, Typography, List, message, Tooltip } from "antd";
import { ShoppingCartOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons'

import ModalCompraProductos from './ModalCompraProductos';
import '../../../Styles/Modules/Customer/customer.css'

import AlmacenProductosList from "./Almacenes/AlmacenProductosList";

const { Content } = Layout;
const { Text } = Typography
const { Panel } = Collapse;
const axios = require('axios')


/**
 * @export
 * @class AlmacenesList
 * @extends {Component}
 * @description Vista de Project Manager
 */
export default class AlmacenesList extends Component {


    constructor(props) {
        super(props)
        this.state = {
            modalVisible: false,
            almacenes: [],

            page: 1,
            limit: 10,
            total: 0,

            searching: true,
            filtroSearch: '',
        }
    }

    /**
   * @method componentDidMount 
   * @description Cargamos la informacion inicial
   */
    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getAlmacenes();
    }



    /**
    * @method componentDidUpdate
    * @description Actualiza la consulta si se buscan datos
    */
    componentDidUpdate() {
        const filtro = this.state.filtroSearch;
        const propFiltro = this.props.search;

        if (filtro !== propFiltro && this.state.searching == true) {
            this.getAlmacenes();
            this.state.searching = false;
        }
    }



    /**
     * @memberof Productos
     * @method getClasificador
     * @description Obtiene los almacenes de los clientes y sus productos
     */
    getAlmacenes = (page = this.state.page) => {
        let search = this.props.search;

        this.setState({ loading: true })
        axios.get('/vmi/almacenes/list-v2', {
            params: {
                almacenes: true,
                page,
                //search
            }
        }).then(response => {
            this.setState({
                almacenes: response.data.data,

                filtroSearch: search,
                searching: true,
                loading: false
            })
        }).catch(error => {
            console.log(error)
            message.error('Error al obtener la información de los almacenes')
        }).finally(() => this.setState({ loading: false }))
    }




    render() {

        return (
            <>
                <Content>
                    <Row>
                        <Col span={24}>
                            <List
                                dataSource={this.state.almacenes}
                                pagination={{
                                    current: this.state.page,
                                    pageSize: this.state.limit,
                                    total: this.state.total,
                                    hideOnSinglePage: true,
                                    position: 'bottom',
                                    className: "flex-left",
                                    change: this.getAlmacenes
                                }}
                                loading={this.state.loading}
                                renderItem={item => (
                                    <Collapse
                                        bordered={false}
                                        defaultActiveKey={['1']}
                                        expandIcon={({ isActive }) => isActive ? <MinusOutlined style={{ marginTop: 13, color: '#ffffff', fontSize: 16 }} /> : <PlusOutlined style={{ marginTop: 13, color: '#ffffff', fontSize: 16 }} />}
                                        className="collapse-almacenes"
                                    >
                                        <Panel
                                            header={
                                                <Row className="width-100 header-collapse ">
                                                    <Col span={11} className="flex-left">
                                                        <Text className="collapse-text-big">{item.direccion}</Text>
                                                    </Col>
                                                    <Col span={6} className="flex-column">
                                                        <Text>Productos</Text>
                                                        <Text>{item.productos?.length}</Text>
                                                    </Col>
                                                    <Col span={5} className="flex-column">
                                                        <Text>Ubicación</Text>
                                                        <Text>{item?.direccion}</Text>
                                                    </Col>

                                                </Row>
                                            }
                                        >
                                            <AlmacenProductosList 
                                                almacen_id={item._id}
                                                inventario_id={item.inventario_id}
                                                search={this.props.search}
                                            />

                                        </Panel>
                                    </Collapse>
                                )}
                            />

                        </Col>
                    </Row>


                    <ModalCompraProductos
                        visible={this.state.modalVisible}
                        onClose={() => {
                            this.setState({
                                modalVisible: false,
                                producto_id: undefined,
                                producto: undefined,
                                cantidad_disp: undefined,
                                almacen_id: undefined,
                                precio: undefined,
                            })
                            this.getAlmacenes()
                        }}
                        producto={this.state.producto}
                        cantidad_disp={this.state.cantidad_disp}
                        cantidad_proceso={this.state.cantidad_proceso}
                        almacen_id={this.state.almacen_id}
                        precio={this.state.precio}
                    />
                </Content>


            </>
        )
    }
}